




import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
import vue from 'vue';
import {colors} from '@/config';

More(Highcharts);

@Component({components: {Chart}})
export default class DynamicCompassBar extends Vue {
  @Prop() financialRatio: any;
  @Prop() ranking: any;
  @Prop() type: string | undefined;
  @Prop() showAll: boolean | undefined;

  chartOptions: any = {
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
    },

    credits: {
      enabled: false,
    },

    title: {
      text: this.getName(),
      style: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
      },
    },

    xAxis: {
      type: 'category',
      labels: {
        autoRotation: [0],
        staggerLines: 1,
        padding: 10,
        style: {
          fontSize: '1rem',
          textOverflow: 'none',
          whiteSpace: 'normal',
          color: colors.Black,
        },
      },
    },

    yAxis: {
      title: {
        text: '',
      },
      opposite: true,
      labels: {
        style: {
          fontSize: '1rem',
        },
        formatter: (point: any) => {
          if (this.financialRatio === 'interestCoverage') {
            return (vue as any).options.filters.D0(point.value);
          }
          return (vue as any).options.filters.P(point.value / 100);
        },
      },
      tickPixelInterval: 175,
      gridLineColor: colors.LightGrey,
      plotLines: [{
        color: colors.Black,
        width: 2,
        value: 0,
        zIndex: 2,
      }],
      softMin: 0,
    },

    legend: {
      enabled: false,
    },

    tooltip: {
      headerFormat: '',
      pointFormat: this.financialRatio === 'interestCoverage'
          ? '<span>{point.name}: <b>{point.y:,.0f} ' + Vue.prototype.$t(' ggr') + '</b></span>'
          : '<span>{point.name}: <b>{point.y:,.1f} %</b></span>',
      style: {
        fontSize: '1.25rem',
      },
      backgroundColor: colors.Light,
    },

    series: [],
  };

  @Watch('ranking', {immediate: true, deep: true})
  rankingChanged() {
    this.chartOptions.series = this.getData();
  }

  getBranch(): any[] {
    if (this.type !== 'industry') {
      return [];
    }
    const s1 = this.ranking.sheets[0];
    return [{
      name: Vue.prototype.$t('Undre kvartil'),
      y: s1.industryKeyValues25[this.financialRatio],
      color: colors.Negative,
    }, {
      name: Vue.prototype.$t('Median'),
      y: s1.industryKeyValues[this.financialRatio],
      color: colors.MidGrey,
    }, {
      name: Vue.prototype.$t('Övre kvartil'),
      y: s1.industryKeyValues75[this.financialRatio],
      color: colors.Positive,
    }];
  }

  getData(): any[] {
    switch (this.financialRatio) {
      default:
        if (!this.ranking) {
          return [];
        }
        let cnt = 3;
        if (this.showAll) {
          cnt = this.ranking.length;
        }
        if (this.type === 'industry') {
          return [{
            name: this.getName(),
            color: colors.Primary,
            pointPadding: 0,
            borderColor: colors.Black,
            data: this.getBranch().concat(this.ranking.sheets.slice(0, cnt).map((p: any, i: number) => ({
              name: p.DATE_TO.slice(0, 7),
              y: p.keyValues[this.financialRatio],
              color: colors.Primary,
            })).reverse()),
          }];
        }
        if (this.type === 'competitionLatest') {
          return [{
            name: this.getName(),
            color: colors.Primary,
            pointPadding: 0,
            borderColor: colors.Black,
            data: this.getBranch().concat(this.ranking.sheets.slice(0, cnt).map((p: any, i: number) => ({
              name: ' '.repeat(p.index) + p.DATE_TO.slice(0, 7),
              y: p.keyValues[this.financialRatio],
              color: p.index === 0 ? colors.Primary : p.index === 1 ? colors.Secondary : colors.Tertiary,
            })).reverse()),
          }];
        }
        return [{
          name: this.getName(),
          color: colors.Primary,
          pointPadding: 0,
          borderColor: colors.Black,
          data: this.getBranch().concat(this.ranking.sheets.slice(0, cnt).map((p: any, i: number) => ({
            name: p.DATE_TO.slice(0, 7),
            y: p.keyValues[this.financialRatio],
            color: i === 0 ? colors.Primary : i === 1 ? colors.Secondary : colors.Tertiary,
          })).reverse()),
        }];
    }
  }

  getName() {
    switch (this.financialRatio) {
      case 'operatingMargin':
        return Vue.prototype.$t('Rörelsemarginal');
      case 'growth':
        return Vue.prototype.$t('Tillväxt');
      case 'solidity':
        return Vue.prototype.$t('Soliditet');
      case 'workingCapitalPct':
        return Vue.prototype.$t('Rörelsekapital i % av nettoomsättningen');
      case 'quickRatio':
        return Vue.prototype.$t('Kassalikviditet');
      case 'interestCoverage':
        return Vue.prototype.$t('Räntetäckningsgrad');
      case 'riskBuffer':
        return Vue.prototype.$t('Riskbuffert');
      case 'returnOnCapital':
        return Vue.prototype.$t('Räntabilitet på eget kapital');
    }
  }

}
